(() => {
  if (window.toscaniIdentity) return;
  window.toscaniIdentity = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Set();
  let scenes = [], frame = 0, previousTime = 0;
  const cardStates = new Map();
  const animateIn = (element, index = 0) => {
    if (window.toscaniMotion?.reveal(element, index)) return;
    if (reduced.matches || !element.animate) return;
    const animation = element.animate([
      { opacity: 0.2, transform: 'perspective(1000px) translateY(32px) rotateX(24deg)' },
      { opacity: 1, transform: 'perspective(1000px) translateY(0) rotateX(0)' }
    ], { duration: 850, delay: Math.min(index * 85, 255), easing: 'cubic-bezier(.16,1,.3,1)' });
    animations.add(animation);
    animation.onfinish = animation.oncancel = () => animations.delete(animation);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      animateIn(entry.target, Number(entry.target.dataset.tcIndex || 0));
      observer.unobserve(entry.target);
    });
  }, { threshold: 0, rootMargin: '0px 0px 300px 0px' }) : null;
  const update = time => {
    frame = 0;
    if (reduced.matches || document.hidden) return;
    const dt = Math.min(50, previousTime ? time - previousTime : 16);
    previousTime = time;
    const blend = 1 - Math.exp(-dt / 85);
    let settling = false;
    const geometry = scenes.map(scene => ({scene, rect: scene.getBoundingClientRect()}));
    geometry.forEach(({scene, rect}) => {
      if (rect.bottom < -100 || rect.top > window.innerHeight + 100) return;
      const target = Math.max(-1, Math.min(1, -rect.top / Math.max(rect.height, 1)));
      const state = cardStates.get(scene);
      if (!state) return;
      state.value += (target - state.value) * blend;
      if (Math.abs(target - state.value) < .0005) state.value = target;
      else settling = true;
      state.cards.forEach((card, index) => {
        card.style.setProperty('--tc-lift', `${state.value * (index === 1 ? -30 : 22)}px`);
        card.style.setProperty('--tc-tilt', `${state.value * (index === 0 ? -8 : 8)}deg`);
      });
    });
    if (settling) frame = requestAnimationFrame(update);
    else previousTime = 0;
  };
  const schedule = () => { if (!frame && !reduced.matches && !document.hidden) frame = requestAnimationFrame(update); };
  const sceneObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('tc-inview', entry.isIntersecting));
  }, {threshold: 0}) : null;
  const init = () => {
    scenes = [...document.querySelectorAll('[data-tc-scene][data-tc-motion="true"]')];
    scenes.forEach(scene => {
      if (!cardStates.has(scene)) cardStates.set(scene, {value: 0, cards: [...scene.querySelectorAll('[data-tc-card]')]});
      if (sceneObserver) sceneObserver.observe(scene); else scene.classList.add('tc-inview'); });
    scenes.forEach(scene => scene.querySelectorAll('[data-tc-reveal]').forEach((element, index) => {
      if (element.dataset.tcReady) return;
      element.dataset.tcReady = 'true';
      element.dataset.tcIndex = String(index % 3);
      if (observer && !reduced.matches) observer.observe(element);
    }));
    // Existing catalog headings share the identity without hiding products or controls.
    document.querySelectorAll('.toscani-store #MainContent .ts-catalog-heading h1, .toscani-home #MainContent .shopify-section:not(:has(.tc)):not(:has(.tm-hero)) h2').forEach(element => {
      if (element.dataset.tcReady) return;
      element.dataset.tcReady = 'true';
      if (observer && !reduced.matches) observer.observe(element);
    });
    schedule();
  };
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-tc-ready]').forEach(element => observer?.unobserve(element));
    scenes.filter(scene => event.target.contains(scene)).forEach(scene => sceneObserver?.unobserve(scene));
    scenes.filter(scene => event.target.contains(scene)).forEach(scene => cardStates.delete(scene));
    scenes = scenes.filter(scene => !event.target.contains(scene));
  });
  document.addEventListener('shopify:section:select', event => {
    event.target.querySelectorAll('[data-tc-ready]').forEach(element => {
      observer?.unobserve(element);
      element.getAnimations().forEach(animation => animation.cancel());
    });
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      cancelAnimationFrame(frame); frame = 0; previousTime = 0;
      cardStates.forEach(state => { state.value = 0; });
      animations.forEach(animation => animation.cancel());
      observer?.disconnect();
      scenes.forEach(scene => scene.querySelectorAll('[data-tc-card]').forEach(card => {
        card.style.removeProperty('--tc-lift'); card.style.removeProperty('--tc-tilt');
      }));
    } else schedule();
  });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('visibilitychange', () => { scenes.forEach(scene => scene.classList.toggle('tc-motion-paused', document.hidden)); schedule(); });
  init();
})();
